import axios from 'axios';
import {backendHost} from '../../config';

export const getOperators = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/operators`, {params});
};